import React from 'react'
import { Stack, Typography, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useTranslation } from 'react-i18next'

interface FieldLabelProps {
  labelKey: string
  tooltip?: string
}

const FieldLabel: React.FC<FieldLabelProps> = ({ labelKey, tooltip }) => {
  const { t } = useTranslation()
  
  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 1 }}>
      <Typography sx={{ fontSize: '10px', fontWeight: 500, color: '#333' }}>
        {t(labelKey)}
      </Typography>
      {tooltip && (
        <Tooltip title={t(tooltip)} placement="top">
          <InfoOutlinedIcon sx={{ fontSize: 12, color: '#999' }} />
        </Tooltip>
      )}
    </Stack>
  )
}

export default FieldLabel